"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactKonva = require("react-konva");
var _Marker = _interopRequireDefault(require("./Marker"));
var _Cursor = _interopRequireDefault(require("./Cursor"));
var _ContextMenu = _interopRequireDefault(require("./ContextMenu"));
var _useDrawing2 = _interopRequireDefault(require("./Hooks/useDrawing"));
var _Group = require("./Group");
var _konva = _interopRequireDefault(require("konva"));
var _utilities = require("../../utilities");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["config", "markers"],
  _excluded2 = ["config", "markers"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } // View.js
// https://github.com/konvajs/react-konva/issues/349#issuecomment-478300618
function Canvas(_ref) {
  var _ref$config = _ref.config,
    config = _ref$config === void 0 ? {} : _ref$config,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? {} : _ref$images,
    _ref$markers = _ref.markers,
    markers = _ref$markers === void 0 ? [] : _ref$markers,
    _ref$rotation = _ref.rotation,
    rotation = _ref$rotation === void 0 ? 0 : _ref$rotation,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? true : _ref$interactive,
    _ref$activeMarker = _ref.activeMarker,
    activeMarker = _ref$activeMarker === void 0 ? "" : _ref$activeMarker,
    _ref$isMarkerLayerVis = _ref.isMarkerLayerVisible,
    isMarkerLayerVisible = _ref$isMarkerLayerVis === void 0 ? true : _ref$isMarkerLayerVis,
    _ref$onMarkerChange = _ref.onMarkerChange,
    onMarkerChange = _ref$onMarkerChange === void 0 ? null : _ref$onMarkerChange,
    _ref$onCursorChange = _ref.onCursorChange,
    onCursorChange = _ref$onCursorChange === void 0 ? null : _ref$onCursorChange,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$onDisplay = _ref.onDisplay,
    onDisplay = _ref$onDisplay === void 0 ? null : _ref$onDisplay;
  // renaming width and height and assigning defaults just in case
  var _config$width = config.width,
    stageWidth = _config$width === void 0 ? 640 : _config$width,
    _config$height = config.height,
    stageHeight = _config$height === void 0 ? 480 : _config$height,
    _config$scale = config.scale,
    canvasScale = _config$scale === void 0 ? 1 : _config$scale,
    _config$hidden = config.hidden,
    hidden = _config$hidden === void 0 ? false : _config$hidden;
  var preview = images.preview,
    vl = images.vl,
    ir = images.ir;
  var stageRef = (0, _react.useRef)(null);
  var irImageRef = (0, _react.useRef)();
  var _useDrawing = (0, _useDrawing2.default)(),
    isDrawing = _useDrawing.isDrawing,
    setDrawingConfig = _useDrawing.setDrawingConfig,
    onDrawingClick = _useDrawing.onDrawingClick,
    onDrawingMove = _useDrawing.onDrawingMove;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedMarkerID = _useState2[0],
    setSelectedMarkerID = _useState2[1];
  var _useState3 = (0, _react.useState)({
      style: "default",
      enabled: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    cursorConfig = _useState4[0],
    setCursorConfig = _useState4[1];
  var _useState5 = (0, _react.useState)({
      enabled: false
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    menuConfig = _useState6[0],
    setMenuConfig = _useState6[1];
  var checkLeftClick = function checkLeftClick(e) {
    return e.evt.button === 0;
  };
  var getPointerPosition = function getPointerPosition() {
    var positionAbsolute = stageRef.current.getPointerPosition();
    return positionAbsolute;
  };
  var getRelativeFromAbsolute = function getRelativeFromAbsolute(_ref2) {
    var X = _ref2.X,
      Y = _ref2.Y,
      x = _ref2.x,
      y = _ref2.y;
    var absolute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    // TODO: PASSING ABSOLUTE BOOL IS TEMPRORARY FIX
    // TODO: ABSOLUTE IS A BOOL PASSED TO FIX TRANSFORMS ON ROTATION

    // get relative position on image from absolute position on stage
    var nextPoint = {
      x: X !== undefined ? X : x,
      y: Y !== undefined ? Y : y
    };

    // copy the current transform on the node
    var transform;
    if (absolute) {
      transform = irImageRef.current.getAbsoluteTransform().copy();
    } else {
      transform = irImageRef.current.getTransform().copy();
    }

    // determine relative position by inverting the transform
    transform.invert();
    var positionRelative = transform.point(nextPoint);

    // return the relative point
    return {
      x: positionRelative.x,
      y: positionRelative.y
    };
  };
  var toRelativeBoundingBox = (0, _react.useCallback)(function (pointA, pointB) {
    var absolute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var toRelative = function toRelative(point) {
      return getRelativeFromAbsolute(point, absolute);
    };
    var relativeA = toRelative(pointA);
    var relativeB = toRelative(pointB);

    // recompute corners
    var UL = {
      x: Math.min(relativeA.x, relativeB.x),
      y: Math.min(relativeA.y, relativeB.y)
    };
    var LR = {
      x: Math.max(relativeA.x, relativeB.x),
      y: Math.max(relativeA.y, relativeB.y)
    };
    return {
      UL: UL,
      LR: LR
    };
  }, []);
  var hasBoundaryCrossing = (0, _react.useCallback)(function () {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var objectsToCheck = ["point", "start", "finish", "UL", "LR"];

    // Helper function to check if x or y of an object is negative
    var isNegative = function isNegative(_ref3) {
      var x = _ref3.x,
        y = _ref3.y;
      return x < 0 || y < 0;
    };

    // Helper function to check if x or y exceeds a certain value
    var exceedsBoundary = function exceedsBoundary(_ref4, thresholdX, thresholdY) {
      var x = _ref4.x,
        y = _ref4.y;
      return x > thresholdX || y > thresholdY;
    };
    return objectsToCheck.some(function (objectKey) {
      var currentObject = attrs[objectKey];

      // Check if x or y is negative or exceeds the specified thresholds
      return currentObject && (isNegative(currentObject) || exceedsBoundary(currentObject, stageWidth, stageHeight));
    });
  }, [stageHeight, stageWidth]);
  var handleMarkerUpdate = (0, _react.useCallback)(function (attrs) {
    var absolute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    // before updating marker, convert absolute position to relative position
    var relativeAttrs = {};
    // TODO: ABSOLUTE IS A BOOL PASSED TO FIX TRANSFORMS ON ROTATION

    var toRelative = function toRelative(point) {
      return getRelativeFromAbsolute(point, absolute);
    };
    switch (attrs.type) {
      case "Circle":
        relativeAttrs = _objectSpread(_objectSpread({}, attrs), {}, {
          point: toRelative(attrs.point)
        });
        break;
      case "Line":
        relativeAttrs = _objectSpread(_objectSpread({}, attrs), {}, {
          start: toRelative(attrs.start),
          finish: toRelative(attrs.finish)
        });
        break;
      case "Rect":
      case "Ellipse":
        relativeAttrs = _objectSpread(_objectSpread({}, attrs), toRelativeBoundingBox(attrs.UL, attrs.LR, absolute));
        break;
      default:
        relativeAttrs = attrs;
    }

    // skip update if update is outside of IR image
    if (hasBoundaryCrossing(relativeAttrs)) return;
    return onMarkerChange === null || onMarkerChange === void 0 ? void 0 : onMarkerChange(relativeAttrs, "update");
  }, [hasBoundaryCrossing, onMarkerChange, toRelativeBoundingBox]);
  var handleCursorTemperature = (0, _react.useCallback)(function (absolutePosition) {
    // before getting cursor temp, convert absolute position to relative position
    var relativePosition = getRelativeFromAbsolute(absolutePosition);
    return onCursorChange(relativePosition);
  }, [onCursorChange]);
  var drawMarker = (0, _react.useCallback)(function (attrs) {
    var _handleMarkerUpdate = handleMarkerUpdate(attrs),
      id = _handleMarkerUpdate.id,
      name = _handleMarkerUpdate.name;
    // update artist on marker they are dealing with
    setDrawingConfig({
      id: id,
      name: name
    });
  }, [setDrawingConfig, handleMarkerUpdate]);
  var saveAsImage = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var stage, tempContainer, newStage;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // save an image of the copied image
          stage = stageRef.current;
          if (stage) {
            tempContainer = document.createElement("div");
            tempContainer.style.display = "none";
            document.body.appendChild(tempContainer);
            newStage = new _konva.default.Stage({
              container: tempContainer,
              width: stageWidth,
              height: stageHeight
            });
            stage.children.forEach(function (layer) {
              if (layer.attrs.name !== "layer-cursor") {
                var clonedLayer = layer.clone({
                  listening: false
                });
                newStage.add(clonedLayer);
              }
            });
            newStage.batchDraw();
            newStage.toImage({
              callback: function callback(props) {
                return onChange === null || onChange === void 0 ? void 0 : onChange(props);
              },
              mimeType: "image/jpeg",
              quality: 1
            });

            // Clean up the temporary stage and container
            newStage.destroy();
            document.body.removeChild(tempContainer);
          }
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [onChange, stageHeight, stageWidth]);

  // LISTENERS ====================================================================
  var handleMouseDown = (0, _react.useCallback)(function (e, type, id) {
    // close the context menu
    setMenuConfig(function (config) {
      return _objectSpread(_objectSpread({}, config), {}, {
        enabled: false
      });
    });

    // when mouse click has been detected
    switch (type) {
      case "marker-click":
        setSelectedMarkerID(id);
        break;
      case "marker-deselect":
        // deselect when clicked anywhere not a marker
        var clickedOnEmpty = e.target.className === "Image";
        if (clickedOnEmpty) {
          setSelectedMarkerID(null);
        }
        break;
      case "drawing":
        // start drawing
        if (!checkLeftClick(e)) break;
        var position = getPointerPosition();
        onDrawingClick(position, drawMarker);
        break;
      default:
    }
  }, [drawMarker, onDrawingClick]);
  var handleMouseMove = (0, _react.useCallback)(function (e) {
    // when mouse is moving
    var pointerPosition = getPointerPosition();
    setCursorConfig(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        text: handleCursorTemperature(pointerPosition),
        position: pointerPosition
      });
    });
    onDrawingMove(pointerPosition, drawMarker);
  }, [onDrawingMove, drawMarker, handleCursorTemperature]);
  var handleMouseEnter = (0, _react.useCallback)(function (e, type) {
    // when mouse enters boundary
    switch (type) {
      case "marker-enter":
        setCursorConfig(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            style: "pointer"
          });
        });
        break;
      default:
        setCursorConfig(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            enabled: true,
            style: "crosshair"
          });
        });
        break;
    }
  }, []);
  var handleMouseLeave = function handleMouseLeave() {
    // when mouse leaves boundary
    setCursorConfig(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        enabled: false,
        style: "default"
      });
    });
  };
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    // delete the selected marker
    if (e.keyCode === 46 || e.key === "Delete") {
      if (selectedMarkerID) {
        onMarkerChange === null || onMarkerChange === void 0 ? void 0 : onMarkerChange(selectedMarkerID, "delete");
      }
    }
  }, [selectedMarkerID, onMarkerChange]);
  var handleContextMenu = (0, _react.useCallback)(function (e, type, item) {
    switch (type) {
      case "menu-select":
        setDrawingConfig({
          type: item
        });
        setMenuConfig(function (config) {
          return _objectSpread(_objectSpread({}, config), {}, {
            enabled: false
          });
        });
        break;
      default:
        e.evt.preventDefault();
        setMenuConfig(function (config) {
          return _objectSpread(_objectSpread({}, config), {}, {
            enabled: true,
            position: getPointerPosition()
          });
        });
        break;
    }
  }, [setDrawingConfig]);
  var debouncedSaveAsImage = (0, _react.useCallback)(
  // debounce catches fringe debounce errors
  (0, _utilities.debounce)(function () {
    saveAsImage();
  }, 50), [saveAsImage]);
  var handleDrawComplete = (0, _react.useCallback)(function (_ref6) {
    var _ref6$debounce = _ref6.debounce,
      debounce = _ref6$debounce === void 0 ? true : _ref6$debounce;
    if (isDrawing === false || menuConfig.enabled) {
      if (debounce) {
        debouncedSaveAsImage();
      } else {
        saveAsImage();
      }
    }
  }, [isDrawing, menuConfig.enabled, debouncedSaveAsImage, saveAsImage]);
  (0, _react.useEffect)(function () {
    // handle external selection active marker tool
    if (activeMarker != null && activeMarker !== "") {
      setDrawingConfig({
        type: activeMarker
      });
    }
  }, [activeMarker, setDrawingConfig]);
  (0, _react.useEffect)(function () {
    return function () {
      // free stage when the component unmounts
      if (stageRef.current) {
        stageRef.current.destroy();
        stageRef.current = null;
      }
    };
  }, []);
  var styles = {
    container: {
      width: stageWidth * canvasScale,
      height: stageHeight * canvasScale,
      visibility: hidden ? "hidden" : "visible",
      display: hidden ? "none" : "block"
    },
    stage: {
      transform: "scale(".concat(canvasScale, ")"),
      transformOrigin: "top left"
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: styles.container,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      tabIndex: "0",
      onKeyDown: handleKeyDown,
      style: styles.stage,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactKonva.Stage, {
        ref: stageRef,
        width: stageWidth,
        height: stageHeight,
        style: {
          cursor: cursorConfig.style
        },
        listening: interactive,
        onMouseDown: function onMouseDown(e) {
          return handleMouseDown(e, "marker-deselect");
        },
        onTouchStart: function onTouchStart(e) {
          return handleMouseDown(e, "marker-deselect");
        },
        onContextMenu: handleContextMenu,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Layer, {
          onDraw: function onDraw() {
            return handleDrawComplete({
              debounce: false
            });
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Group.RotationGroup, {
            rotation: rotation,
            children: [vl && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Image, {
              id: "image-vl",
              name: "image-vl",
              image: vl,
              x: 0,
              y: 0,
              width: stageWidth,
              height: stageHeight
            }), ir && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Image, {
              ref: irImageRef,
              id: "image-ir",
              name: "image-ir",
              image: ir,
              x: (stageWidth - stageWidth * (ir.width / vl.width)) / 2,
              y: (stageHeight - stageHeight * (ir.height / vl.height)) / 2,
              width: stageWidth * (ir.width / vl.width),
              height: stageHeight * (ir.height / vl.height),
              onMouseEnter: handleMouseEnter,
              onMouseLeave: handleMouseLeave,
              onMouseMove: handleMouseMove,
              onMouseDown: function onMouseDown(e) {
                return handleMouseDown(e, "drawing");
              }
            }), preview && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Image, {
              id: "image-preview",
              image: preview,
              x: 0,
              y: 0,
              width: stageWidth,
              height: stageHeight,
              visible: !(vl && ir)
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactKonva.Layer, {
          visible: isMarkerLayerVisible,
          listening: !isDrawing,
          onDraw: function onDraw() {
            return handleDrawComplete({
              debounce: true
            });
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Group.RotationGroup, {
            rotation: rotation,
            center: {
              x: stageWidth / 2,
              y: stageHeight / 2
            },
            children: markers.map(function (_ref7) {
              var id = _ref7.id,
                type = _ref7.type,
                data = _ref7.data;
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Marker.default, {
                id: id,
                type: type,
                data: data,
                rotation: -rotation,
                formatDisplayTemperature: function formatDisplayTemperature(coords) {
                  return onDisplay === null || onDisplay === void 0 ? void 0 : onDisplay(coords);
                },
                isSelected: id === selectedMarkerID,
                onMouseDown: function onMouseDown(e) {
                  return handleMouseDown(e, "marker-click", id);
                },
                onMouseEnter: function onMouseEnter(e) {
                  return handleMouseEnter(e, "marker-enter", id);
                },
                onMarkerUpdate: function onMarkerUpdate(attrs) {
                  return handleMarkerUpdate(attrs, false);
                }
              }, id);
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactKonva.Layer, {
          name: "layer-cursor",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Cursor.default, {
            config: cursorConfig
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContextMenu.default, {
            config: menuConfig,
            onSelect: function onSelect(item) {
              return handleContextMenu(null, "menu-select", item);
            }
          })]
        })]
      })
    })
  });
}
function arePropsEqual() {
  var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _prevProps$config = prevProps.config,
    prevConfig = _prevProps$config === void 0 ? {} : _prevProps$config,
    _prevProps$markers = prevProps.markers,
    prevMarkers = _prevProps$markers === void 0 ? [] : _prevProps$markers,
    restPrevProps = _objectWithoutProperties(prevProps, _excluded);
  var _nextProps$config = nextProps.config,
    nextConfig = _nextProps$config === void 0 ? {} : _nextProps$config,
    _nextProps$markers = nextProps.markers,
    nextMarkers = _nextProps$markers === void 0 ? [] : _nextProps$markers,
    restNextProps = _objectWithoutProperties(nextProps, _excluded2);
  var prevEntries = Object.entries(restPrevProps);
  var nextEntries = Object.entries(restNextProps);

  // do prop lengths match? -----------------------------------------
  if (prevEntries.length !== nextEntries.length) {
    return false;
  }

  // check all props but config object ------------------------------
  for (var _i = 0, _prevEntries = prevEntries; _i < _prevEntries.length; _i++) {
    var _prevEntries$_i = _slicedToArray(_prevEntries[_i], 2),
      key = _prevEntries$_i[0],
      value = _prevEntries$_i[1];
    if (nextProps[key] !== value) {
      return false;
    }
  }

  // check config object --------------------------------------------
  var prevConfigEntries = Object.entries(prevConfig);
  var nextConfigEntries = Object.entries(nextConfig);
  if (prevConfigEntries.length !== nextConfigEntries.length) {
    return false;
  }
  for (var _i2 = 0, _prevConfigEntries = prevConfigEntries; _i2 < _prevConfigEntries.length; _i2++) {
    var _prevConfigEntries$_i = _slicedToArray(_prevConfigEntries[_i2], 2),
      _key = _prevConfigEntries$_i[0],
      _value = _prevConfigEntries$_i[1];
    if (nextConfig[_key] !== _value) {
      return false;
    }
  }

  // check markers coordinates --------------------------------------
  var keysToCheck = ["markerPixelIndexFinish", "markerPixelIndexFinish_OutputImageCoordinates", "markerPixelIndexStart", "markerPixelIndexStart_OutputImageCoordinates", "markerPixelIndexLR", "markerPixelIndexLR_OutputImageCoordinates", "markerPixelIndexUL", "markerPixelIndexUL_OutputImageCoordinates", "markerPixelIndex", "markerPixelIndex_OutputImageCoordinates"];
  for (var _i3 = 0, _keysToCheck = keysToCheck; _i3 < _keysToCheck.length; _i3++) {
    var _key2 = _keysToCheck[_i3];
    for (var i = 0; i < nextMarkers.length; i++) {
      var _prevMarkers$i, _prevMarkers$i$data, _nextMarkers$i, _nextMarkers$i$data;
      if (((_prevMarkers$i = prevMarkers[i]) === null || _prevMarkers$i === void 0 ? void 0 : (_prevMarkers$i$data = _prevMarkers$i.data) === null || _prevMarkers$i$data === void 0 ? void 0 : _prevMarkers$i$data[_key2]) !== ((_nextMarkers$i = nextMarkers[i]) === null || _nextMarkers$i === void 0 ? void 0 : (_nextMarkers$i$data = _nextMarkers$i.data) === null || _nextMarkers$i$data === void 0 ? void 0 : _nextMarkers$i$data[_key2])) {
        // Change detected, return false to trigger rerender
        return false;
      }
    }
  }

  // No changes detected, return true to prevent rerender -----------
  return true;
}
var _default = exports.default = /*#__PURE__*/_react.default.memo(Canvas, arePropsEqual);